import React from "react";
import { useReactFlow } from "reactflow";

type HelperLinesProps = {
    horizontal?: number;
    vertical?: number;
    verticalStart?: number;
    verticalEnd?: number;
};

const LineColor = "#DB2A4A";

export const HelperLines = React.memo(function HelperLines({ horizontal, vertical, verticalStart, verticalEnd }: HelperLinesProps) {
    const { getViewport } = useReactFlow();
    const viewport = getViewport();

    if (horizontal === undefined && vertical === undefined && verticalStart === undefined && verticalEnd === undefined)
        return null;

    return (
        <svg
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                zIndex: 10
            }}
        >
            {horizontal !== undefined && (
                <line
                    x1="0"
                    y1={horizontal * viewport.zoom + viewport.y}
                    x2="100%"
                    y2={horizontal * viewport.zoom + viewport.y}
                    stroke={LineColor}
                    strokeWidth="1"
                    strokeDasharray="5,5"
                />
            )}
            {/* Center vertical line */}
            {vertical !== undefined && (
                <line
                    x1={vertical * viewport.zoom + viewport.x}
                    y1="0"
                    x2={vertical * viewport.zoom + viewport.x}
                    y2="100%"
                    stroke={LineColor}
                    strokeWidth="1"
                    strokeDasharray="5,5"
                />
            )}
            {/* Start vertical line */}
            {verticalStart !== undefined && (
                <line
                    x1={verticalStart * viewport.zoom + viewport.x}
                    y1="0"
                    x2={verticalStart * viewport.zoom + viewport.x}
                    y2="100%"
                    stroke={LineColor}
                    strokeWidth="1"
                    strokeDasharray="5,5"
                />
            )}
            {/* End vertical line */}
            {verticalEnd !== undefined && (
                <line
                    x1={verticalEnd * viewport.zoom + viewport.x}
                    y1="0"
                    x2={verticalEnd * viewport.zoom + viewport.x}
                    y2="100%"
                    stroke={LineColor}
                    strokeWidth="1"
                    strokeDasharray="5,5"
                />
            )}
        </svg>
    );
});
